import { Modal } from "@bca/ui-library";
import { FunctionComponent } from "react";
import styled from "styled-components";
import { LayoutProps, SpaceProps, layout, space } from "styled-system";
import useImpersonationModal from "../../hooks/useImpersonationModal.hook";
import ImpersonationModalContent from "./ImpersonationModalContent";
import useDeviceType from "../../hooks/useDeviceType.hook";

const StyledModal = styled(Modal)<LayoutProps & SpaceProps>`
  ${layout};
  ${space};
`;

interface ImpersonationModalProps {
  userRole: string | string[];
  vrm: string;
}

const ImpersonationModal: FunctionComponent<ImpersonationModalProps> = ({
  userRole,
  vrm,
}) => {
  const {
    isImpersonationModalOpen,
    closeImpersonationModal,
    isImpersonationSessionExpired,
  } = useImpersonationModal(userRole);

  const { isMobileDevice } = useDeviceType();

  const mobileDeviceHeight = isImpersonationSessionExpired ? "264px" : "371px";
  const nonMobileDeviceHeight = isImpersonationSessionExpired
    ? "295px"
    : "329px";

  return (
    <>
      {isImpersonationModalOpen && (
        <StyledModal
          showXButton={false}
          onClose={closeImpersonationModal}
          overlayVariant="dark"
          width={isMobileDevice ? "335px" : "599px"}
          height={isMobileDevice ? mobileDeviceHeight : nonMobileDeviceHeight}
          padding={0}
          data-testid="impersonation-modal"
        >
          <ImpersonationModalContent
            isMobileDevice={isMobileDevice}
            vrm={vrm}
          />
        </StyledModal>
      )}
    </>
  );
};

export default ImpersonationModal;
